export default "__VITE_ASSET__BPiILouN__"